import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const AppSumoCodeInput = () => {
  return <VpHookFormInput maxLength={10} required name="appSumoCode" placeholder="AppSumo Code" />;
};

export default AppSumoCodeInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-up/AppSumoCodeInput.jsx